<script>

    import { toast } from 'bulma-toast'
    import { replace } from 'svelte-spa-router'
    import { userStore, shipmentStore, shipmentsStore, modalStore, notifyStore } from '../stores'

    import ShipmentsService from '../$services/shipments.service'
    import OrdersService from '../$services/orders.service'
    import DateMethod from '../$methods/date.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import Delete from '../$components/delete.svelte'

    const { HOST_APP } = _CONSTANTS_

    let data = {}
    let loading = false
    let element = null
    let referenceInput = null

    async function cancelShipment() {

        loading = true
        const resp = await ShipmentsService.cancelShipment($shipmentStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        shipmentStore.set(resp.data)
        shipmentsStore.replace(resp.data)

        toast({message: 'Guía cancelada', type: 'is-success'})
        notifyStore.set('wallet_updated')
    }

    function onCopy() {
        referenceInput.select()
        referenceInput.setSelectionRange(0, 99999)
        document.execCommand("copy")
        toast({message: 'Link copiado', type: 'is-success'})
    }

    async function createOrder() {

        const data = {
            pickup: $shipmentStore.order.pickup,
            delivery: $shipmentStore.order.delivery,
            package: $shipmentStore.order.package
        }

        loading = true
        const resp = await OrdersService.createOrder(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: 'Orden duplicada', type: 'is-success'})
        modalStore.close()
        replace('#/orders')
    }

    function logJSON(obj) {
        console.log(JSON.stringify(obj, null, 4))
    }

    async function downloadGuide() {

        loading = true
        const blob = await ShipmentsService.getShipmentZPL($shipmentStore._id)
        loading = false

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        element.download = `${$shipmentStore.guide}.zpl`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

    async function downloadSignature() {

        loading = true
        const blob = await ShipmentsService.getShipmentSignature($shipmentStore._id)
        loading = false

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        element.download = `${$shipmentStore.guide}.pdf`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

    async function updateShipmentGuideTIL(documentFormat) {

        loading = true
        const resp = await ShipmentsService.updateShipmentGuideTIL($shipmentStore._id, { documentFormat })
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: 'Guía generada correctamente', type: 'is-success'})

        shipmentStore.set(resp.data)
        shipmentsStore.replace(resp.data)
    }

</script>

<a bind:this={element} style="display: none;" href="/">.</a>

{#if $shipmentStore}
    <div class="columns">
        <div class="column">

            <div class="title">{ $shipmentStore.provider }</div>
            <div class="subtitle">{ $shipmentStore.service }</div>
            <br>
            <div class="title">Orden</div>
            <div class="subtitle">#{ $shipmentStore.order.number }</div>
            <br>
            <div class="title">Guia</div>
            <div class="subtitle">{ $shipmentStore.guide }</div>
            <br>

        </div>
        <div class="is-divider-vertical"></div>
        <div class="column">

            {#if !$userStore.hidePrices}
                <div class="title">Precio final</div>
                <div class="subtitle">{ NumeralMethods.cash($shipmentStore.pricing.finalPrice) }</div>
                <br>
            {/if}

            <div class="title">Fecha</div>
            <div class="subtitle">{ DateMethod.dateTimeLarge($shipmentStore.created) }</div>
            
            <div class="tags">
                <br>
                {#if !$shipmentStore.isDeliveryHome}
                    <span class="tag is-danger">Sin entrega a domicilio</span>
                {/if}
    
                {#if $shipmentStore.isCoverageCost}
                    <span class="tag is-danger">Zona extendida</span>
                {/if}
    
                {#if $shipmentStore.order.isOccurs}
                    <span class="tag is-danger">Entrega Ocurre</span>
                {/if}
                <br>
            </div>

            {#if $shipmentStore.status != 'canceled'}

                {#if $shipmentStore.provider === 'Sendex'}
                    <button on:click={ downloadGuide } class="button is-light is-fullwidth is-{ loading? 'loading' : '' }">
                        Descargar ZPL
                    </button>
                {/if}

                {#if $shipmentStore.signature}
                    <button on:click={ downloadSignature } class="button is-primary is-fullwidth">
                        Descargar POD
                    </button>
                {/if}

                {#if $shipmentStore.provider === 'TIL' && $shipmentStore.documentFormat == 'pdf'}
                    <button on:click={() => updateShipmentGuideTIL('6x4')} class="button is-outlined is-fullwidth is-{ loading? 'loading' : '' }">
                        Generar etiqueta 6X4
                    </button>
                {/if}

                {#if $shipmentStore.provider === 'TIL' && $shipmentStore.documentFormat == '6x4'}
                    <button on:click={() => updateShipmentGuideTIL('pdf')} class="button is-outlined is-fullwidth is-{ loading? 'loading' : '' }">
                        Generar etiqueta PDF
                    </button>
                {/if}

                <a href="{ $shipmentStore.document }" class="button is-primary is-fullwidth" target="_blank">
                    <span class="icon"><i class="fas fa-file-pdf"></i></span>
                    <span>Descargar guía</span>
                </a>
            {/if}
        </div>
    </div>
    <br>

    {#if $shipmentStore.status === 'canceled'}
        <div class="columns">
            <div class="is-divider"></div>
            <div class="column">
                <div class="title" >Guía cancelada</div>
                <div class="subtitle">{ DateMethod.dateTimeLarge($shipmentStore.states.canceled) }</div>
                {#if $shipmentStore.refund}
                    <div>Reembolso</div>
                    <div>{ DateMethod.dateTimeLarge($shipmentStore.refund.created) }</div>
                {/if}
            </div>
        </div>
    {/if}

    {#if $shipmentStore.lastTracking }
        <div class="columns">
            <div class="is-divider"></div>
            <div class="column">
                <div class="title">Último status</div>
                <div style="padding-top: 0">
                    <p class="heading">{ $shipmentStore.lastTracking.name }</p>
                    <div>
                        <div>{ $shipmentStore.lastTracking.details }</div>
                        <small>{ DateMethod.dateTimeLarge($shipmentStore.lastTracking.created) }</small>
                    </div>
                </div>
            </div>
        </div>
    {/if}

    {#if $shipmentStore.status != 'canceled'}
        <div class="columns">
            <div class="column">
                <div class="title">Link de rastreo</div>
                <div class="items-space-around">
                    <input bind:this={ referenceInput } value={`${HOST_APP}/#/trackings/${ $shipmentStore.code }`} class="input space-right" readonly>
                    <button on:click={onCopy} class="button" data-tooltip="Copiar link">
                        <span class="icon"><i class="fas fa-copy"></i></span>
                    </button>
                </div>
            </div>
        </div>
    {/if}

    <br>
    <div class="columns">
        <div class="column" on:dblclick={() => logJSON($shipmentStore.order.pickup)}>
            <div class="title">Origen</div>
            <div style="padding-top: 0">
                <div><b>{ $shipmentStore.order.pickup.contact }</b></div>
                <div>{ $shipmentStore.order.pickup.rfc || 'Sin información' }</div>
                <div>{ $shipmentStore.order.pickup.corporate || 'Sin información' }</div>
                <div>{ $shipmentStore.order.pickup.phone }</div>
                <div>{ $shipmentStore.order.pickup.email }</div>
                <div>{ $shipmentStore.order.pickup.street }</div>
                <div>{ $shipmentStore.order.pickup.number }, { $shipmentStore.order.pickup.apartment || '' }</div>
                <div>{ $shipmentStore.order.pickup.colony }</div>
                <div><b>{ $shipmentStore.order.pickup.zipcode }</b>, { $shipmentStore.order.pickup.city }, { $shipmentStore.order.pickup.state }</div>
                <div>{ $shipmentStore.order.pickup.references }</div>
                {#if $shipmentStore.order.pickup.address}
                    <div class="space-top">
                        <a target="_blank" href="https://www.google.com/maps/search/?api=1&query={$shipmentStore.order.pickup.position.lat},{ $shipmentStore.order.pickup.position.lng }">
                            Google Maps
                        </a>
                    </div>
                    <div><small>{$shipmentStore.order.pickup.address}</small></div>
                {/if}
            </div>
        </div>
        <div class="is-divider-vertical"></div>
        <div class="column" on:dblclick={() => logJSON($shipmentStore.order.delivery)}>
            <div class="title">Destino</div>
            <div style="padding-top: 0">
                <div><b>{ $shipmentStore.order.delivery.contact }</b></div>
                <div>{ $shipmentStore.order.delivery.rfc || 'Sin información' }</div>
                <div>{ $shipmentStore.order.delivery.corporate || 'Sin información' }</div>
                <div>{ $shipmentStore.order.delivery.phone }</div>
                <div>{ $shipmentStore.order.delivery.email }</div>
                <div>{ $shipmentStore.order.delivery.street }</div>
                <div>{ $shipmentStore.order.delivery.number }, { $shipmentStore.order.delivery.apartment || '' }</div>
                <div>{ $shipmentStore.order.delivery.colony }</div>
                <div><b>{ $shipmentStore.order.delivery.zipcode }</b>, { $shipmentStore.order.delivery.city }, { $shipmentStore.order.delivery.state }</div>
                <div>{ $shipmentStore.order.delivery.references }</div>
                {#if $shipmentStore.order.delivery.address}
                    <div class="space-top">
                        <a target="_blank" href="https://www.google.com/maps/search/?api=1&query={$shipmentStore.order.delivery.position.lat},{ $shipmentStore.order.delivery.position.lng }">
                            Google Maps
                        </a>
                    </div>
                    <div><small>{$shipmentStore.order.delivery.address}</small></div>
                {/if}
            </div>
        </div>
    </div>
    <br>
    <div class="columns">
        <div class="column" on:dblclick={() => logJSON($shipmentStore.order.package)}>
            <div class="title">Paquete</div>
            <div style="padding-top: 0">
                <div>{ $shipmentStore.order.package.width }cm x { $shipmentStore.order.package.height }cm x { $shipmentStore.order.package.length} cm </div>
                <div>{ $shipmentStore.order.package.weight }Kg Físico</div>
                <div>{ $shipmentStore.order.package.volumetric }Kg Volumétrico</div>
            </div>
        </div>
        <div class="is-divider-vertical"></div>
        <div class="column">
            <div class="title">Contenido</div>
            <div style="padding-top: 0">
                <div>Valor declarado ${ $shipmentStore.order.package.value }</div>
                <div>{ $shipmentStore.order.package.content }</div>
            </div>
        </div>
    </div>
    <br>
    {#if $shipmentStore.order.merchandises && $shipmentStore.order.merchandises.length}
        <div class="columns">
            <div class="column">
                <div class="title">Mercancias</div>
                <table class="table is-fullwidth">
                    <thead>
                        <tr>
                            <th>Cantidad</th>
                            <th>Producto</th>
                            <th>Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each $shipmentStore.order.merchandises as merchandise}
                            <tr>
                                <td>{ merchandise.items }</td>
                                <td>{ merchandise.product.name }</td>
                                <td>${ merchandise.value }</td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </div>
    {/if}
    <br>
    <div class="columns" style="margin-bottom: 0 !important;">
        <div class="column">
            <button on:click={createOrder} class="button is-fullwidth">
                <span class="icon"><i class="fas fa-copy"></i></span>
                <span>Duplicar órden</span>
            </button>
        </div>
        {#if $shipmentStore.status != 'canceled' && $shipmentStore.trackingStatus === 'Guía generada' && !$shipmentStore.order.pickup.position}
            <div class="column">
                <button on:click={() => modalStore.set('shipment_update_guide')} class="button is-fullwidth">
                    <span class="icon"><i class="fas fa-sync"></i></span>
                    <span>Actualizar envío</span>
                </button>
            </div>
        {/if}
    </div>

    <div class="columns">
        {#if $shipmentStore.status != 'canceled' && $shipmentStore.tracking.length <= 1}
            {#if $shipmentStore.provider != 'Estafeta'}
                <div class="column">
                    <button on:click={() => cancelShipment()} class="button is-fullwidth">
                        <span class="icon"><i class="fas fa-ban"></i></span>
                        <span>Cancelar envío</span>
                    </button>
                </div>
            {/if}
        {/if}
        {#if $shipmentStore.status != 'canceled'}
            <div class="column">
                <button on:click={() => modalStore.set('ticket_create_modal')} class="button is-fullwidth">
                    <span class="icon"><i class="fas fa-exclamation-triangle"></i></span>
                    <span>Tuve un problema con mi envío</span>
                </button>
            </div>
        {/if}
    </div>

    <div class="columns">
        {#if $shipmentStore.status != 'canceled' && $shipmentStore.trackingStatus === 'Guía generada'}
            <div class="column">
                <button on:click={() => modalStore.set('pickup_create_modal')} class="button is-primary is-fullwidth">
                    <span class="icon"><i class="fas fa-people-carry"></i></span>
                    <span>Agendar recolección</span>
                </button>
            </div>
        {/if}
    </div>

{/if}